// CMS blocks contain no executable JavaScript. Delegate clicks so copy buttons
// continue working when Turbolinks replaces the page body.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cms-copy]');
  if (!button) return;

  const text = button.getAttribute('data-cms-copy');
  if (!text) return;

  const originalHtml = button.innerHTML;
  const showCopied = () => {
    button.textContent = '¡Copiado!';
    window.setTimeout(() => { button.innerHTML = originalHtml; }, 2000);
  };

  const legacyCopy = () => {
    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    const copied = document.execCommand('copy');
    input.remove();
    if (copied) showCopied();
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(showCopied).catch(legacyCopy);
  } else {
    legacyCopy();
  }
});
